import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const userSet = localStorage.getItem('illumidev_lang_user_set');
    const savedLang = localStorage.getItem('illumidev_language') || localStorage.getItem('language');
    if (userSet && (savedLang === 'es' || savedLang === 'en')) {
      return savedLang;
    }
  }
  return 'en'; // Default English
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    localStorage.setItem('illumidev_language', language);
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    localStorage.setItem('illumidev_lang_user_set', '1');
    setLanguage((currentLanguage) => (currentLanguage === 'es' ? 'en' : 'es'));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
